import { PaymentIcon, PaymentType, SubPaymentType } from './types'

export const localPaymentMethodMap: {
  [type in PaymentType]:
    | {
        [subType in SubPaymentType]?: {
          icon: PaymentIcon
          basketOrder?: number
        }
      }
    | { icon: PaymentIcon; basketOrder?: number }
} = {
  [PaymentType.AFTER_PAY]: { icon: PaymentIcon.AFTER_PAY },
  [PaymentType.ALI_PAY]: { icon: PaymentIcon.ALI_PAY },
  [PaymentType.AMAZONPAY]: { icon: PaymentIcon.AMAZONPAY },
  [PaymentType.ALI_PAY_PLUS]: { icon: PaymentIcon.ALI_PAY_PLUS },
  [PaymentType.ATOME]: { icon: PaymentIcon.ATOME },
  [PaymentType.APPLE_PAY]: { icon: PaymentIcon.APPLE_PAY },
  [PaymentType.ARVATO]: { icon: PaymentIcon.ARVATO },
  [PaymentType.ADYEN]: {
    [SubPaymentType.DINERS_CLUB]: { icon: PaymentIcon.DINERS_CLUB },
    [SubPaymentType.DISCOVER]: { icon: PaymentIcon.DISCOVER },
    [SubPaymentType.GIROPAY]: { icon: PaymentIcon.GIRO_PAY },
    [SubPaymentType.IDEAL]: { icon: PaymentIcon.IDEAL },
    [SubPaymentType.INTERAC]: { icon: PaymentIcon.INTERAC },
    [SubPaymentType.JCB]: { icon: PaymentIcon.JCB },
    [SubPaymentType.KCP]: { icon: PaymentIcon.KCP },
    [SubPaymentType.MOL_PAY]: { icon: PaymentIcon.MOL_PAY },
    [SubPaymentType.PAYPAL]: { icon: PaymentIcon.PAYPAL },
    [SubPaymentType.PAYTM]: { icon: PaymentIcon.PAYTM },
    [SubPaymentType.PRIMEIRO_PAY]: { icon: PaymentIcon.PRIMEIRO_PAY },
    [SubPaymentType.QIWI_WALLET]: { icon: PaymentIcon.QIWI_WALLET },
    [SubPaymentType.SEPA]: { icon: PaymentIcon.SEPA },
    [SubPaymentType.SOFORT]: { icon: PaymentIcon.SOFORT },
    [SubPaymentType.TRUSTLY]: { icon: PaymentIcon.TRUSTLY },
    [SubPaymentType.TRUST_PAY]: { icon: PaymentIcon.TRUST_PAY },
    [SubPaymentType.UNION_PAY]: { icon: PaymentIcon.UNION_PAY },
    [SubPaymentType.CUP]: { icon: PaymentIcon.UNION_PAY },
    [SubPaymentType.BANCONTACT]: { icon: PaymentIcon.BANCONTACT },
  },
  [PaymentType.CLEAR_PAY]: { icon: PaymentIcon.CLEAR_PAY },
  [PaymentType.GIFT_CARD]: { icon: PaymentIcon.GIFT_CARD },
  [PaymentType.GOOGLE_PAY]: { icon: PaymentIcon.GOOGLE_PAY },
  [PaymentType.KLARNA_LATER]: { icon: PaymentIcon.KLARNA, basketOrder: -2 },
  [PaymentType.KLARNA_SLICE]: {
    icon: PaymentIcon.KLARNA_SLICE,
    basketOrder: -2,
  },
  [PaymentType.KLARNA_NOW]: { icon: PaymentIcon.KLARNA, basketOrder: -2 },
  [PaymentType.KLARNA]: { icon: PaymentIcon.KLARNA, basketOrder: -2 },
  [PaymentType.LAY_BUY]: { icon: PaymentIcon.LAY_BUY },
  [PaymentType.MODE]: { icon: PaymentIcon.MODE },
  [PaymentType.MULTIBANCO]: { icon: PaymentIcon.MULTIBANCO },
  [PaymentType.NEWPAY]: { icon: PaymentIcon.NEWPAY },
  [PaymentType.OPEN_PAY]: { icon: PaymentIcon.OPEN_PAY },
  [PaymentType.PAYPAL]: { icon: PaymentIcon.PAYPAL, basketOrder: -1 },
  [PaymentType.PAYPAL_IN_3]: { icon: PaymentIcon.PAYPAL_IN_3, basketOrder: -1 },
  [PaymentType.PAYVYNE]: { icon: PaymentIcon.PAYVYNE },
  [PaymentType.QUAD_PAY]: { icon: PaymentIcon.QUAD_PAY },
  [PaymentType.SEZZLE]: { icon: PaymentIcon.SEZZLE },
  [PaymentType.SPLIT_IT]: { icon: PaymentIcon.SPLIT_IT },
  [PaymentType.SPOTII]: { icon: PaymentIcon.SPOTII },
  [PaymentType.WE_CHAT_PAY]: { icon: PaymentIcon.WE_CHAT_PAY },
  [PaymentType.VISA_CHECKOUT]: { icon: PaymentIcon.VISA_CHECKOUT },
  [PaymentType.ZIP_PAY]: { icon: PaymentIcon.ZIP_PAY },
  [PaymentType.RAZORPAY]: {
    [SubPaymentType.VISA]: { icon: PaymentIcon.VISA_CHECKOUT },
    [SubPaymentType.MASTERCARD]: { icon: PaymentIcon.MASTERCARD },
    [SubPaymentType.UPI]: { icon: PaymentIcon.UPI },
  },
}
